// project import
import config from './config';
import contacts from './contacts';
import contracts from './contracts';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [contracts, contacts, config]
};

export default menuItems;
